export const formatExternalPrefillIdsForInput = externalPrefillIds => {
  if (!Array.isArray(externalPrefillIds)) {
    return '';
  }

  return externalPrefillIds.filter(Boolean).join(', ');
};

export const parseExternalPrefillIdsFromInput = value => {
  if (!value) {
    return [];
  }

  return String(value)
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
};
